<template>
  <ul class="nav" :class="['index' + pAIndex, {'layout-line': layout == 'line'}]">
    <li class="col-xs-12 p-x-0 order-item adjust text-no-adjust" v-if="!adjusts.length && !isBigMilk && !isIce"><div>此商品不需調整配料/比例</div></li>
    <li class="col-xs-12 p-x-0 order-item adjust text-no-adjust" v-if="!adjusts.length && isBigMilk">
      <div>
        嚴選乳源、成分無調整<br><br>
        <span class="text-red text-14">★ 此商品不列入外送金額，尚請見諒</span><br>
        <span class="text-red text-14">★ 為保持鮮奶品質，外送建議一公里內</span><br>
        <!--<span class="text-red text-14">★ 2/1~2/28 買兩瓶於門市結帳時，只需298元！</span>-->
      </div>
    </li>
    <li class="col-xs-12 p-x-0 order-item adjust text-no-adjust" v-if="!adjusts.length && isIce">
      <div>
        成分無調整<br><br>
        <span class="text-red text-14">★ 此商品為冰萃/冰沙口感，現場選購口感較佳，不建議外送時選購</span><br>
      </div>
    </li>
    <li class="col-xs-12 p-x-0 order-item adjust"
      v-for="(adjust, aIndex) in adjusts"
      v-if="adjust"
      :class="['adjust-' + currentProduct[schema.product.product_id] + '-' + adjust[schema.adjust.product_id], 'adjust-' + currentProduct[schema.product.product_id]]"
      :key="currentProduct[schema.product.product_id] + '-' + adjust[schema.adjust.product_id]"
    >
      <h4>{{adjust[schema.adjust.name]}}選擇
        <span style="top: 0px" v-if="adjust[schema.adjust.max_limit] != 1 && adjust[schema.adjust.max_limit] != 0">(最多可選{{adjust[schema.adjust.max_limit]}}項)</span>
      </h4>
      <div style="margin-left: -5px" :class="'options-' + currentProduct[schema.product.product_id] + '-' + aIndex" class="options">
        <div
          v-for="(option, oIndex) in adjust[schema.adjust.option_list]"
          class="btn btn-default btn-option"
          @click="clickOption(option, oIndex, adjust, aIndex)"
          :class="[
            { disabled: adjust[schema.adjust.is_enable] == 0 },
            'option-' + currentProduct[schema.product.product_id] + '-index' + pAIndex,
            { 'btn-option--active': isActive(currentProduct[schema.product.product_id] + '-' + adjust[schema.adjust.product_id] + '-' + option[schema.option.product_id]) }
          ]"
          :id="'option-' + currentProduct[schema.product.product_id] + '-' + option[schema.option.product_id]"
          :optionA="'adjust-' + adjust[schema.adjust.product_id]"
          :key="currentProduct[schema.product.product_id] + '-' + adjust[schema.adjust.product_id] + '-' + option[schema.option.product_id]"
        >
          <div class="option-name">
            {{option[schema.option.name]}}
          </div>
          <div
            v-if="Array.isArray(option) && Array.isArray(adjust) && optionPrice(option, adjust)"
            class="option-price"
          >
            {{ optionPrice(option, adjust) }}
          </div>
          <div class="label option-number" v-if="optionNumList[0][option[schema.option.product_id]] && optionNumList[0][option[schema.option.product_id]] !== 1">
            {{optionNumList[0][option[schema.option.product_id]]}}
          </div>
          <div class="label option-number" v-else-if="optionNumList[0][option[schema.option.product_id]] && optionNumList[0][option[schema.option.product_id]] === 1 && option[schema.option.max_limit] !== 1">
            {{optionNumList[0][option[schema.product.product_id]]}}
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import $ from 'jquery'
import parse from '../../../../assets/js/parse-menu.js'

export default{
  props: {
    currentProduct: [Object, Array],
    checkPrice: Function,
    checkAddProduct: Function,
    checkAddDifProduct: Function,
    optionCheck: Object,
    productAmount: Number,
    pAIndex: Number,
    menuJson: [Object, String],
    isInit: Boolean,
    paAdjusts: Array,
    layout: String,
    prodType: String,
    clickProduct: Function
  },
  data () {
    return {
      isVisible: [],
      tags: 0,
      isOption: [],
      isShow: [],
      cartMount: 0,
      orderInfo: {
        orderId: 0,
        storeId: parseInt(this.$route.params.storeId, 10),
        version: 0,
        // gb
        orderType: 1,
        isEmpty: 0
      },
      totalPrice () {
        return parseInt(this.number, 10) * parseInt(this.price, 10)
      },
      combineId: '',
      adjusts: [],
      adjustsIndexMapping: {},
      optionsIndexMapping: {},
      counter: 0,
      limitList: [],
      productCombineIds: [],
      number: 1,
      price: 0,
      currentMenuJson: '',
      storeId: this.$route.params.storeId,
      schema: {
        category: {},
        product: {},
        icon: {},
        image: {},
        tag: {},
        adjust: {},
        option: {},
        combine: {},
        edge: {},
        common: {},
        block: {}
      },
      menu: {
        categoryList: {},
        productList: {},
        adjustList: {},
        optionList: {},
        combineList: {}
      },
      // 選項數量
      optionNum: {},
      optionNumList: [{}],
      optionCurr: [],
      // 選取組合
      passCombinations: []
    }
  },
  methods: {
    adjustsOfProduct (productId) {
      return this.getProduct(productId)[this.schema.product.adjust_list]
    },
    optionsOfAdjust (adjustId) {
      return this.getAdjust(adjustId)[this.schema.adjust.option_list]
    },
    combinesOfProduct (productId) {
      return this.getProduct(productId)[this.schema.product.combine_list]
    },
    getProduct (productId) {
      return this.menu.productList[productId]
    },
    getAdjust (adjustId) {
      return this.menu.adjustList[adjustId]
    },
    getOption (optionId) {
      return this.menu.optionList[optionId]
    },
    getCombine (combineId) {
      return this.menu.combineList[combineId]
    },
    isActive (optionId) {
      return this.optionCurr.includes(optionId)
    },
    isHOption (adjust) {
      var aSchema = this.schema.adjust
      if (adjust[aSchema.sub_type] === 0) {
        if (adjust[aSchema.name].indexOf('溫') > -1) return false
        else if (adjust[aSchema.name].indexOf('甜') > -1) return false
        else if (adjust[aSchema.name].indexOf('糖') > -1) return false
        else if (adjust[aSchema.name].indexOf('冰') > -1) return false
        return true
      } else if (adjust[aSchema.sub_type] === 10) return true
      else if (adjust[aSchema.sub_type] === 20) return true
      return false
    },
    optionPrice (option, adjust) {
      try {
        // 1. 參數驗證
        if (!option || !this.schema) {
          return 0
        }

        const { adjust: aSchema, combine: cSchema, option: oSchema, edge: eSchema } = this.schema
        const oPrice = option[oSchema.price]

        // 2. 基本價格格式化
        const formatPrice = (price) => {
          if (price === undefined || price === null) return 0
          if (price > 0) return `+${price}元`
          if (price < 0) return `${price}元`
          return '+0元'
        }

        // 3. 組合價格處理
        if (this.isHOption(adjust) && this.passCombinations && this.passCombinations[0]) {
          const combination = this.passCombinations.find(
            (obj) => this.combineId === obj[cSchema.combine_id]
          )

          if (combination && !combination.edge_list) {
            return formatPrice(oPrice)
          }

          // 4. 檢查產品價格
          let productPrice
          let adjustPrice

          if (combination && combination.edge_list && option && option[oSchema.product_id]) {
            const edgeList = combination.edge_list[option[oSchema.product_id]]
            if (edgeList) {
              productPrice = edgeList[eSchema.price]
            }
          }

          if (combination && combination.edge_list && adjust && adjust[aSchema.product_id]) {
            const edgeList = combination.edge_list[adjust[aSchema.product_id]]
            if (edgeList) {
              adjustPrice = edgeList[eSchema.price]
            }
          }

          if (productPrice !== undefined) {
            return formatPrice(productPrice)
          }

          if (adjustPrice !== undefined) {
            return formatPrice(adjustPrice)
          }
        }

        return formatPrice(oPrice)
      } catch (error) {
        console.error('價格計算錯誤:', error)
        return 0
      }
    },
    showOption (aIndex, isMandatory) {
      var self = this
      if (typeof isMandatory === 'undefined' || isMandatory) {
        $('.index' + this.pAIndex + ' .options-' + this.currentProduct[this.schema.product.product_id] + '-' + aIndex).slideToggle(function () {
          var visible = $(this).is(':visible')
          if (visible) self.isVisible.push(aIndex)
          else self.removeArray(self.isVisible, aIndex)
        })
      }
    },
    parsePrice (product) {
      // Schema
      const pSchema = this.schema.product
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option
      var productId = product[pSchema.product_id]
      var price
      var type
      var checkP = this.getProduct(productId)
      var checkA = this.getAdjust(productId)
      var checkO = this.getOption(productId)
      var isOption = []
      var minPrice = []
      if (checkP) {
        // console.log(checkP)
        price = checkP[pSchema.price]
        type = 'p'
        var aList = checkP[pSchema.adjust_list]
        aList = parse.divideList(aList, this.getAdjust)
        for (var j = 0; j < aList.length; j++) {
          var aListPrice = []
          var tag = 0
          for (var k = 0; k < aList[j][aSchema.option_list].length; k++) {
            tag++
            aListPrice.push(aList[j][aSchema.option_list][k][oSchema.price])
            if (tag === aList[j][aSchema.option_list].length) minPrice.push(Math.min.apply(Math, aListPrice))
          }
        }
        for (var m = 0; m < aList.length; m++) {
          // var min = aList[j][aSchema.min_limit]
          var max = aList[m][aSchema.max_limit]
          var tags = 1
          for (var n = 0; n < aList[m][aSchema.option_list].length; n++) {
            if (aList[m][aSchema.option_list][n][oSchema.price] === minPrice[m] && tags <= max) {
              tags++
              if (aList[m][aSchema.is_mandatory]) isOption.push({adjust: aList[m], option: aList[m][aSchema.option_list][n]})
            }
          }
        }
        // console.log(isOption)
      } else if (checkA) {
        // console.log(checkA)
        price = checkA[aSchema.price]
        type = 'a'
        if (price === null) {
          for (var i = 0; i < checkA[aSchema.option_list].length; i++) {
            if (checkA[aSchema.option_list][i][oSchema.is_mandatory]) {
              price = price + checkA[aSchema.option_list][i][oSchema.price]
            }
          }
        }
      } else if (checkO) {
        // console.log(checkO)
        price = checkO[oSchema.price]
        type = 'o'
      }
      if (isOption.length) this.isOption = isOption
      return {price: price, type: type}
    },
    showAll (product, combines) {
      // Schema
      const pSchema = this.schema.product
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option

      // Data
      var adjustIds = product[pSchema.adjust_list]
      var result = []

      // Fill Up adjust.option_list with option
      for (var adjustIndex = 0; adjustIndex < adjustIds.length; adjustIndex++) {
        var adjust = parse.divideList(adjustIds, this.getAdjust)[adjustIndex]
        if (adjust) {
          adjust.activeCount = 0
          adjust.activeOptionIds = []
          for (var optionIndex = 0; optionIndex < adjust[aSchema.option_list].length; optionIndex++) {
            if (typeof adjust[aSchema.option_list][optionIndex] === 'number') {
              adjust[aSchema.option_list][optionIndex] = this.getOption(adjust[aSchema.option_list][optionIndex])
              adjust[aSchema.option_list][optionIndex].activeCount = 0
            }
          }
          adjust[aSchema.option_list].sort(function (a, b) {
            if (a[oSchema.sort] > b[oSchema.sort]) {
              return 1
            }
            if (a[oSchema.sort] < b[oSchema.sort]) {
              return -1
            }

            return 0
          })
          result.push(adjust)
        }
      }
      // 排adjust順序 (尺寸, 溫度, 甜度, 加料)
      // 排序 (數字為 sub_type) => (尺寸 10) > (溫度 40 > 甜度 30 > 容器 20) > (其他 0)
      // 括弧內依據 sort 變更排序，相同則依據建置時間顯示
      // ex: sort = 尺寸 3、溫度 3、甜度 2、其他(1) 2、其他(2) 1
      // 尺寸
      const size = result.filter((adjust) => {
        return adjust[aSchema.sub_type] === 10
      }).sort((a, b) => {
        return a[aSchema.sort] - b[aSchema.sort]
      })
      // 系統 (排序相同時，顯示預設值)
      const system = result.filter((adjust) => {
        return adjust[aSchema.sub_type] && adjust[aSchema.sub_type] !== 10
      }).sort((a, b) => { // 預設值：溫度 40 > 甜度 30 > 容器 20
        return b[aSchema.sub_type] - a[aSchema.sub_type]
      }).sort((a, b) => {
        return a[aSchema.sort] - b[aSchema.sort]
      })
      // 其他
      const others = result.filter((adjust) => {
        return !adjust[aSchema.sub_type]
      }).sort((a, b) => {
        return a[aSchema.sort] - b[aSchema.sort]
      })
      // 排序後：尺寸 3、甜度 2、溫度 3、其他(2) 1、其他(1) 2
      return size.concat(system, others)
    },
    filterCombine (combines) {
      //  Schema
      const oSchema = this.schema.option
      const cSchema = this.schema.combine
      const eSchema = this.schema.edge
      const aSchema = this.schema.adjust
      const pSchema = this.schema.product
      const pId = this.currentProduct[pSchema.product_id]
      this.isShow = []

      // filter combination
      $('.option-' + pId + '-index' + this.pAIndex).css('display', 'none')
      var combine = parse.divideList(combines, this.getCombine)
      for (var cIndex = 0; cIndex < combine.length; cIndex++) {
        for (var oIndex in combine[cIndex][cSchema.edge_list]) {
          this.isShow.push(combine[cIndex][cSchema.edge_list][oIndex][eSchema.product_id])
        }
      }
      this.isShow = this.isShow.filter(function (elem, index, self) {
        return self.indexOf(elem) === index
      })
      for (var id = 0; id < this.isShow.length; id++) {
        var num = this.isShow[id]
        if (this.getOption(num)) {
          // show
          $('.index' + this.pAIndex + ' #option-' + pId + '-' + this.getOption(num)[oSchema.product_id]).css('display', 'inline-block')
        } else if (this.getAdjust(num)) {
          // show
          var options = this.getAdjust(num)[aSchema.option_list]
          for (var o = 0; o < options.length; o++) {
            $('.index' + this.pAIndex + ' #option-' + pId + '-' + options[o][oSchema.product_id]).css('display', 'inline-block')
          }
        }
      }
    },
    createMapping (arrayData, idIndex) {
      var mapping = {}
      for (var i = 0; i < arrayData.length; i++) {
        mapping[arrayData[i][idIndex]] = i
      }

      return mapping
    },
    createOptionMapping (adjusts) {
      // Schema
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option

      // Data
      var mapping = {}
      for (var i = 0; i < adjusts.length; i++) {
        for (var j = 0; j < adjusts[i][aSchema.option_list].length; j++) {
          mapping[adjusts[i][aSchema.option_list][j][oSchema.product_id]] = {
            adjustIndex: i,
            optionIndex: j
          }
        }
      }

      return mapping
    },
    search (id, adjusts, productId) {
      var result = []
      var aSchema = this.schema.adjust
      // var product = this.getProduct(id)
      var adjust = this.getAdjust(id)
      var option = this.getOption(id)
      if (option) {
        result.push(option)
        return result
        // if edge is option
      } else {
        if (adjust) {
          // result.push(adjust)
          option = parse.divideList(adjust[aSchema.option_list], this.getOption)
          for (var i = 0; i < option.length; i++) {
            result.push(option[i])
          }

          /*
          result[1].sort(function (a, b) {
            return b[7] - a[7]
          })
          */
          return result
        }
        /*
        else {
          if (product) {
            // if edge product
            result.push(product)
            return result
          }
        }
        */
      }
      /*
      for (var i = 0; i < adjusts.length; i++) {
        if (id === adjusts[i]) {
          result.push(id)
        }
      }
      */
    },
    setOptionNum (id, count) {
      this.$set(this.optionNum, id, count)
      this.$set(this, 'optionNumList', [this.optionNum])
    },
    clickOption (clickedOption, clickedOptionIndex, clickedAdjust, clickedAdjustIndex) {
      // var self = this
      // Schema
      const pSchema = this.schema.product
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option
      const currentProduct = { ...this.currentProduct }
      const pId = currentProduct[pSchema.product_id]
      // const cSchema = this.schema.combine

      // Disable Animation
      $('.index' + this.pAIndex + ' #option-' + pId + '-' + clickedOption[oSchema.product_id]).unbind('mouseenter mouseleave')

      // Data
      // 0.
      var clickedAdjustId = clickedAdjust[aSchema.product_id]
      var clickedOptionId = clickedOption[oSchema.product_id]
      var productAdjustIds = this.currentProduct[pSchema.adjust_list]
      // var productCombineIds = this.currentProduct[pSchema.combine_list]
      var adjustIndex = 0
      var adjust = null
      // var optionIndex = 0
      var option = null
      var blockedOptionIds = []
      var bOptionId
      var oId = clickedOptionId
      // Add All mandatory Class on Click
      for (adjustIndex = 0; adjustIndex < productAdjustIds.length; adjustIndex++) {
        adjust = this.getAdjust(productAdjustIds[adjustIndex])
        if (adjust[aSchema.is_mandatory] === true) {
          $('.index' + this.pAIndex + ' .adjust-' + pId + '-' + productAdjustIds[adjustIndex]).addClass('mandatory')
        }
      }
      const pdAdOpId = pId + '-' + clickedAdjustId + '-' + clickedOptionId
      const opIndex = this.optionCurr.findIndex((item) => {
        return item === pdAdOpId
      })
      if (opIndex === -1) {
        this.optionCurr.push(pdAdOpId)
      } else {
        this.optionCurr.splice(opIndex, 1)
      }

      var passCombinations = this.ruleValidation()
      // Click Flow
      // 1. 假如是取消點選(此處定義為取消點選全部，亦即該 Option 有同樣的三份，就是這三個都取消)
      /*
      if ($('#option-' + pId + '-' + clickedOptionId).attr('active')) {
        this.removeArray(clickedAdjust.activeOptionIds, clickedOptionId)
        clickedAdjust.activeCount -= clickedOption.activeCount
        clickedOption.activeCount = 0
        $('#option-' + pId + '-' + clickedOptionId).removeAttr('active', false)
        $('#option-' + pId + '-' + clickedOptionId).removeClass('active')
        for (adjust of this.adjusts) {
          $('.adjust-' + pId + '-' + adjust[aSchema.product_id] + ' div').removeClass('btn-blocked')
        }
        blockedOptionIds = this.getBlockedOptionIds(passCombinations)
        for (bOptionId of blockedOptionIds) {
          $('#option-' + pId + '-' + bOptionId).addClass('btn-blocked')
        }
        this.price = this.calculatePriceBySelectedOptions(passCombinations)
        this.addProduct()
        return
      }
      */
      // 2. 選取並檢查是否超過此 Option 上限
      clickedAdjust.activeOptionIds.push(clickedOptionId)
      clickedAdjust.activeCount++
      clickedOption.activeCount++
      this.setOptionNum(oId, clickedOption.activeCount)
      $('.index' + this.pAIndex + ' #option-' + pId + '-' + clickedOptionId).attr('active', true)
      /* option 最大值暫時為1 */
      var maxLimit = 1
      // var maxLimit = clickedOption[oSchema.max_limit]
      var aMaxLimit = clickedAdjust[aSchema.max_limit]
      if (maxLimit > aMaxLimit && aMaxLimit) maxLimit = aMaxLimit
      if (clickedOption.activeCount > maxLimit && maxLimit) {
        /*
        Toast.create.negative({
          html: '此選項最多只能加' + clickedOption[oSchema.max_limit] + '份喔！',
          timeout: 2500
        })
        */
        if ($('.index' + this.pAIndex + ' #option-' + pId + '-' + clickedOptionId).attr('active')) {
          this.removeArray(clickedAdjust.activeOptionIds, clickedOptionId)
          clickedAdjust.activeCount -= clickedOption.activeCount
          clickedOption.activeCount = 0
          this.setOptionNum(oId, 0)
          $('.index' + this.pAIndex + ' #option-' + pId + '-' + clickedOptionId).removeAttr('active', false)
          $('.index' + this.pAIndex + ' #option-' + pId + '-' + clickedOptionId).removeClass('active')
          for (adjust of this.adjusts) {
            $('.index' + this.pAIndex + ' .adjust-' + pId + '-' + adjust[aSchema.product_id] + ' div').removeClass('btn-blocked')
          }
          blockedOptionIds = this.getBlockedOptionIds(passCombinations)
          for (bOptionId of blockedOptionIds) {
            $('.index' + this.pAIndex + ' #option-' + pId + '-' + bOptionId).addClass('btn-blocked')
          }
          this.price = this.calculatePriceBySelectedOptions(passCombinations)
          this.addProduct()
          if (clickedOption[oSchema.is_mandatory]) {
            // 必選者再被點擊一次
            this.clickOption(clickedOption, clickedOptionIndex, clickedAdjust, clickedAdjustIndex)
          }
          return
        }
      }

      // 3. 如果規則驗證失敗就全部重來
      passCombinations = this.ruleValidation()
      if (passCombinations.length === 0) {
        // Remove
        for (adjust of this.adjusts) {
          adjust.activeOptionIds = []
          adjust.activeCount = 0
          for (option of adjust[aSchema.option_list]) {
            option.activeCount = 0
            this.optionNumList[0][option[oSchema.product_id]] = 0
          }
          $('.index' + this.pAIndex + ' .adjust-' + pId + '-' + adjust[aSchema.product_id] + ' div').removeAttr('active')
          $('.index' + this.pAIndex + ' .adjust-' + pId + '-' + adjust[aSchema.product_id] + ' div').removeClass('active')
          $('.index' + this.pAIndex + ' .adjust-' + pId + '-' + adjust[aSchema.product_id] + ' div').removeClass('btn-blocked')
        }
        // Then Add
        clickedAdjust.activeOptionIds.push(clickedOptionId)
        clickedAdjust.activeCount = 1
        clickedOption.activeCount = 1
        this.setOptionNum(oId, 1)
        $('.index' + this.pAIndex + ' #option-' + pId + '-' + clickedOptionId).attr('active', true)
        /*
        Toast.create.negative({
          html: '因為不支援此種組合，所以重新選擇！',
          timeout: 2500
        })
        */
        /*
        self.$notify({
          title: '訊息',
          text: '因為不支援此種組合，所以重新選擇！',
          duration: 3000,
          type: 'danger',
          width: 400
        })
        */
      }

      // 4. 超過這個 Adjust 上限，這個 Adjust 全部重來
      if (clickedAdjust.activeCount > clickedAdjust[aSchema.max_limit] && clickedAdjust[aSchema.max_limit]) {
        // Remove
        clickedAdjust.activeOptionIds = []
        clickedAdjust.activeCount = 0
        for (option of clickedAdjust[aSchema.option_list]) {
          if (option[oSchema.product_id] !== oId) {
            option.activeCount = 0
            const removeOId = option[oSchema.product_id]
            this.setOptionNum(removeOId, 0)
          }
        }
        $('.index' + this.pAIndex + ' .adjust-' + pId + '-' + clickedAdjustId + ' div').removeAttr('active')
        $('.index' + this.pAIndex + ' .adjust-' + pId + '-' + clickedAdjustId + ' div').removeClass('active')
        for (adjust of this.adjusts) {
          $('.index' + this.pAIndex + ' .adjust-' + pId + '-' + adjust[aSchema.product_id] + ' div').removeClass('btn-blocked')
        }
        // Then Add
        clickedAdjust.activeOptionIds.push(clickedOptionId)
        clickedAdjust.activeCount = this.optionNum[oId]
        clickedOption.activeCount = this.optionNum[oId]
        this.setOptionNum(oId, this.optionNum[oId])
        $('.index' + this.pAIndex + ' #option-' + pId + '-' + clickedOptionId).attr('active', true)

        // Toast.create.negative({
        //   html: clickedAdjust[aSchema.name] + '只能選 ' + clickedAdjust[aSchema.max_limit] + ' 種喔！',
        //   timeout: 2500
        // })
      }

      // 5.
      passCombinations = this.ruleValidation()
      blockedOptionIds = this.getBlockedOptionIds(passCombinations)
      for (bOptionId of blockedOptionIds) {
        $('.index' + this.pAIndex + ' #option-' + pId + '-' + bOptionId).addClass('btn-blocked')
      }
      this.addProduct()
      this.price = this.calculatePriceBySelectedOptions(passCombinations)
      this.checkMandatory(clickedOption, clickedOptionIndex, clickedAdjust, clickedAdjustIndex)
      this.passCombinations = passCombinations
    },
    checkMandatory (clickedOption, clickedOptionIndex, clickedAdjust, clickedAdjustIndex) {
      var self = this
      var aSchema = this.schema.adjust
      var oSchema = this.schema.option
      // Check is mandatory
      clickedAdjust[aSchema.option_list].forEach(function (option, oIndex) {
        if (option[oSchema.is_mandatory] && option[oSchema.product_id] !== clickedOption[oSchema.product_id]) {
          self.clickOption(option, oIndex, clickedAdjust, clickedAdjustIndex)
        }
      })
    },
    // 規則驗證
    ruleValidation () {
      // Schema
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option
      const cSchema = this.schema.combine
      const eSchema = this.schema.edge

      // 使用所有已經選取的 Options 篩選出 Combinations constrainCombList
      var constrainCombList = []
      var adjust = null
      var option = null
      var combineId = null
      var combine = null
      var edge = null
      var isExist = false
      // 把 combination 分開來檢查
      for (combineId of this.productCombineIds) {
        combine = this.menu.combineList[combineId]
        // 掃描所有已經選取的 Options，看看是不是全部都在這個 combination 下
        var allInGraph = true
        for (adjust of this.adjusts) {
          for (option of adjust[aSchema.option_list]) {
            if (option.activeCount > 0) {
              //
              isExist = false
              for (var edgeId in combine[cSchema.edge_list]) {
                edge = combine[cSchema.edge_list][edgeId]
                switch (edge[eSchema.product_type]) {
                  // Option = 2
                  case 2:
                    if (edge[eSchema.product_id] === option[oSchema.product_id]) {
                      isExist = true
                    }
                    break
                  // Adjust = 20
                  case 20:
                    if (edge[eSchema.product_id] === adjust[aSchema.product_id]) {
                      isExist = true
                    }
                    break
                }
                if (isExist) {
                  break
                }
              }
              if (!isExist) {
                allInGraph = false
                break
              }
            }
          }
          if (!allInGraph) {
            break
          }
        }
        if (allInGraph) {
          constrainCombList.push(combine)
        }
      }

      return constrainCombList
    },
    // 取得禁選的 Option IDs
    getBlockedOptionIds (constrainCombList) {
      // Schema
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option
      const cSchema = this.schema.combine
      const eSchema = this.schema.edge

      // 使用所有已經選取的 Options 篩選出 Combinations constrainCombList
      var blockedOptionIds = []
      var adjust = null
      var option = null
      var combine = null
      var edge = null
      var edgeId = null
      var isExist = false

      // 找出不在 constrainCombList 中的 Options
      for (adjust of this.adjusts) {
        for (option of adjust[aSchema.option_list]) {
          //
          isExist = false
          for (combine of constrainCombList) {
            for (edgeId in combine[cSchema.edge_list]) {
              edge = combine[cSchema.edge_list][edgeId]
              switch (edge[eSchema.product_type]) {
                // Option = 2
                case 2:
                  if (edge[eSchema.product_id] === option[oSchema.product_id]) {
                    isExist = true
                  }
                  break
                // Adjust = 20
                case 20:
                  if (edge[eSchema.product_id] === adjust[aSchema.product_id]) {
                    isExist = true
                  }
                  break
              }
              if (isExist) {
                break
              }
            }
            if (isExist) {
              break
            }
          }
          if (!isExist) {
            blockedOptionIds.push(option[oSchema.product_id])
          }
        }
      }

      return blockedOptionIds
    },
    calculatePriceBySelectedOptions (constrainCombList) {
      // Schema
      const pSchema = this.schema.product
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option
      const cSchema = this.schema.combine
      const eSchema = this.schema.edge

      // Data
      var minPrice = 0
      var maxCombineId = 0
      var maxPrice = 0
      var adjustIndex = null
      var adjust = null
      var optionMapping = null
      var option = null

      // Logic
      for (var combine of constrainCombList) {
        var price = 0
        if (combine[cSchema.price] !== null) {
          price = combine[cSchema.price]
          if (price < minPrice) {
            minPrice = price
          }
          if (price > maxPrice) {
            maxPrice = price
            maxCombineId = combine[cSchema.combine_id]
          }
          continue
        }
        for (var edgeId in combine[cSchema.edge_list]) {
          var edge = combine[cSchema.edge_list][edgeId]
          switch (edge[eSchema.product_type]) {
            // Product = 1
            case 1:
              // 確認edge的product有沒有價格
              if (edge[eSchema.price]) price += edge[eSchema.price]
              else price += this.getProduct(edge[eSchema.product_id])[pSchema.price]
              break
            // Option = 2
            case 2:
              optionMapping = this.optionsIndexMapping[edge[eSchema.product_id]]
              option = this.adjusts[optionMapping.adjustIndex][aSchema.option_list][optionMapping.optionIndex]
              if (option.activeCount > 0) {
                if (edge[eSchema.price] === null) {
                  price += (Number(option[oSchema.price]) * option.activeCount)
                } else {
                  price += (edge[eSchema.price] * option.activeCount)
                }
              }
              break
            // Adjust = 20
            case 20:
              // 這個 case 要考慮三件事情，「edge」、「adjust」、「option 的加總」
              adjustIndex = this.adjustsIndexMapping[edge[eSchema.product_id]]
              adjust = this.adjusts[adjustIndex]
              var isActiveAdjust = false
              var adjustPrice = 0
              for (option of adjust[aSchema.option_list]) {
                if (option.activeCount > 0) {
                  isActiveAdjust = true
                  adjustPrice += (option[oSchema.price] * option.activeCount)
                }
              }
              if (isActiveAdjust) {
                if (edge[eSchema.price] !== null) {
                  price += edge[eSchema.price]
                } else if (adjust[aSchema.price] !== null) {
                  price += adjust[aSchema.price]
                } else {
                  price += adjustPrice
                }
              }
              break
          }
        }
        if (price < minPrice) {
          minPrice = price
        }
        if (price > maxPrice) {
          maxPrice = price
          maxCombineId = combine[cSchema.combine_id]
        } else maxCombineId = this.currentProduct[pSchema.combine_list][cSchema.combine_id]
      } // end_of_constrainCombList

      this.combineId = maxCombineId
      return maxPrice
    },
    getSessionName (type, storeId) {
      if (type === 'version') {
        return 'Nidin_' + storeId + '_menuVersion'
      } else if (type === 'menu') {
        return 'Nidin_' + storeId + '_menu'
      } else {
        return false
      }
    },
    removeArray (arr, value) {
      var index = arr.indexOf(value)
      if (index > -1) {
        arr.splice(index, 1)
      }
    },
    init () {
      if (this.menuJson !== undefined) {
        this.currentMenuJson = this.menuJson
        this.menu.categoryList = this.currentMenuJson.category_list_json.data
        this.menu.productList = this.currentMenuJson.product_list_json.data
        this.menu.adjustList = this.currentMenuJson.adjust_list_json.data
        this.menu.optionList = this.currentMenuJson.option_list_json.data
        this.menu.combineList = this.currentMenuJson.combine_list_json.data

        this.schema.category = this.currentMenuJson.category_list_json.schema
        this.schema.product = this.currentMenuJson.product_list_json.schema
        this.schema.icon = this.currentMenuJson.product_list_json.icon_schema
        this.schema.img = this.currentMenuJson.product_list_json.img_schema
        this.schema.tag = this.currentMenuJson.product_list_json.tag_schema
        this.schema.adjust = this.currentMenuJson.adjust_list_json.schema
        this.schema.option = this.currentMenuJson.option_list_json.schema
        this.schema.combine = this.currentMenuJson.combine_list_json.schema
        this.schema.edge = this.currentMenuJson.combine_list_json.edge_schema
        this.schema.common = this.currentMenuJson.combine_list_json.common_schema
        if (this.currentMenuJson.block_list_json) this.schema.block = this.currentMenuJson.block_list_json.schema
      }
      this.initOptions()
    },
    clickAdd () {
      var self = this
      // Schema
      const pSchema = this.schema.product
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option
      // const cSchema = this.schema.combine
      // const eSchema = this.schema.edge
      const pId = this.currentProduct[pSchema.product_id]

      // Data
      var mandatoryLack = false
      var minLack = false

      // Find mandatoryLack & minLack
      for (var adjust of this.adjusts) {
        // 文字
        var pName = this.currentProduct[pSchema.name] + '的'
        var noChose = adjust[aSchema.name] + '未選'
        var atLeast = adjust[aSchema.name] + '至少要選 ' + adjust[aSchema.min_limit] + ' 項'
        if (this.prodType === 'package') {
          noChose = pName + noChose
          atLeast = pName + atLeast
        }

        if (adjust[aSchema.is_mandatory] && adjust.activeCount === 0) {
          mandatoryLack = true
          /*
          Toast.create.negative({
            html: noChose,
            timeout: 2500
          })
          */
          self.$notify({
            title: '訊息',
            text: noChose,
            duration: 3000,
            type: 'danger',
            width: 400
          })
          if (this.prodType === 'package') {
            self.clickProduct(self.currentProduct)
          }
          /*
          setTimeout(function () {
            self.setBtnDis(false)
          }, 2500)
          */
          break
        }
        if (adjust[aSchema.min_limit] > 0 && adjust.activeCount > 0 && adjust.activeCount < adjust[aSchema.min_limit]) {
          minLack = true
          /*
          Toast.create.negative({
            html: atLeast,
            timeout: 2500
          })
          */
          self.$notify({
            title: '訊息',
            text: atLeast,
            duration: 3000,
            type: 'danger',
            width: 400
          })
          if (this.prodType === 'package') {
            self.clickProduct(self.currentProduct)
          }
          /*
          setTimeout(function () {
            self.setBtnDis(false)
          }, 2500)
          */
          break
        }
        for (var option of adjust[aSchema.option_list]) {
          // 文字
          var require = option[oSchema.name] + '是' + adjust[aSchema.name] + '的必選項目'
          var atLeastO = option[oSchema.name] + '從 ' + option[oSchema.min_limit] + ' 份起跳'
          if (this.prodType === 'package') {
            require = pName + require
            atLeastO = pName + atLeastO
          }

          var isShow = $('.index' + this.pAIndex + ' #option-' + pId + '-' + option[oSchema.product_id]).css('display')
          if (adjust.activeCount > 0 && option[oSchema.is_mandatory] && option.activeCount === 0 && isShow !== 'none') {
            mandatoryLack = true
            /*
            Toast.create.negative({
              html: require,
              timeout: 2500
            })
            */
            self.$notify({
              title: '訊息',
              text: require,
              duration: 3000,
              type: 'danger',
              width: 400
            })
            if (this.prodType === 'package') {
              self.clickProduct(self.currentProduct)
            }
            /*
            setTimeout(function () {
              self.setBtnDis(false)
            }, 2500)
            */
            break
          }
          if (adjust.activeCount > 0 && option[aSchema.min_limit] > 0 && option.activeCount > 0 && option.activeCount < option[aSchema.min_limit]) {
            minLack = true
            /*
            Toast.create.negative({
              html: atLeastO,
              timeout: 2500
            })
            */
            self.$notify({
              title: '訊息',
              text: atLeastO,
              duration: 3000,
              type: 'danger',
              width: 400
            })
            if (this.prodType === 'package') {
              self.clickProduct(self.currentProduct)
            }
            /*
            setTimeout(function () {
              self.setBtnDis(false)
            }, 2500)
            */
            break
          }
        }
      }
      if (!mandatoryLack && !minLack) {
        // 可以添加商品
        return true
      }
      // 不可添加商品
      return false
    },
    clearOption () {
      // Schema
      const aSchema = this.schema.adjust
      const pSchema = this.schema.product
      const oSchema = this.schema.option
      const pId = this.currentProduct[this.schema.product.product_id]

      // Clear Tmp Data
      this.limitList = {}
      for (var adjust of this.adjusts) {
        adjust.activeOptionIds = []
        adjust.activeCount = 0
        for (var option of adjust[aSchema.option_list]) {
          option.activeCount = 0
          this.optionNum[option[oSchema.product_id]] = 0
        }
      }

      // Restore UI
      this.$nextTick(function () {
        $('.index' + this.pAIndex + ' .adjust-' + pId + ' .btn-option').removeAttr('active')
        $('.index' + this.pAIndex + ' .adjust-' + pId + ' .btn-option').removeClass('active')
        $('.index' + this.pAIndex + ' .adjust-' + pId + ' .btn-option').attr('disabled', false)
        $('.index' + this.pAIndex + ' .adjust-' + pId + ' .btn-option').removeClass('disabled')
        $('.index' + this.pAIndex + ' .adjust-' + pId + ' .btn-option').removeClass('btn-blocked')
      })
      this.number = 1
      // this.setBtnDis(false)
      if (this.prodType === 'package') this.price = 0
      else if (this.combineProductPrice) this.price = this.combineProductPrice
      else this.price = this.currentProduct[pSchema.price]
      this.optionNum = {}
      this.optionNumList = Array.isArray(this.optionNumList) ? this.optionNumList.slice(0, this.optionNumList.length - 1) : []
      this.optionNumList.push(this.optionNum)
      this.addProduct()
    },
    addProduct () {
      // Schema
      const pSchema = this.schema.product
      const aSchema = this.schema.adjust
      const oSchema = this.schema.option
      // const cSchema = this.schema.combine
      // const eSchema = this.schema.edge

      // Data
      // var self = this
      var products = {
        items: [
          {
            product_id: this.currentProduct[pSchema.product_id],
            type: 1,
            amount: this.number,
            combine_id: this.combineId,
            options: [],
            adjusts: []
          }
        ]
      }

      // 不同的商品內容
      var product = {
        items: [
          {
            product_id: this.currentProduct[pSchema.product_id],
            type: 1,
            amount: 1,
            combine_id: this.combineId,
            options: [],
            adjusts: []
          }
        ]
      }
      // products.items[0].additional_products.push()
      // 需增加是否有選擇修飾條件的判斷
      // ajax call 可以在vuex action中載入
      for (var adjust of this.adjusts) {
        if (adjust.activeCount > 0) {
          var adjustP = {
            adjust_id: parseInt(adjust[aSchema.product_id], 10),
            options: []
          }
          for (var option of adjust[aSchema.option_list]) {
            if (option.activeCount > 0) {
              const oAmount = this.optionNumList[0][option[oSchema.product_id]]
              adjustP.options.push({option_id: parseInt(option[oSchema.product_id], 10), amount: oAmount})
            }
          }
          products.items[0].adjusts.push(adjustP)
          product.items[0].adjusts.push(adjustP)
        }
      }
      this.checkAddProduct(products)
      // 不同的商品內容
      if (this.pAIndex) this.checkAddDifProduct(product, this.pAIndex)
    },
    initOptions () {
      var self = this
      var pSchema = this.schema.product
      var cSchema = this.schema.combine
      var aSchema = this.schema.adjust
      var oSchema = this.schema.option
      // this.setBtnDis(false)
      if (this.prodType === 'package') {
        var passCombinations = this.ruleValidation()
        this.price = this.calculatePriceBySelectedOptions(passCombinations)
      } else if (this.combineProductPrice) this.price = this.combineProductPrice
      else this.price = this.currentProduct[pSchema.price]
      this.combineId = this.currentProduct[pSchema.combine_list][cSchema.combine_id]
      this.productCombineIds = this.currentProduct[this.schema.product.combine_list]
      this.adjusts = this.showAll(this.currentProduct, this.productCombineIds)
      this.adjustsIndexMapping = this.createMapping(this.adjusts, this.schema.adjust.product_id)
      this.optionsIndexMapping = this.createOptionMapping(this.adjusts)
      this.clearOption()
      this.$nextTick(function () {
        this.filterCombine(this.productCombineIds)
        // show default option
        /*
        for (var j = 0; j < this.isOption.length; j++) {
          var option = this.isOption[j].option
          var adjust = this.isOption[j].adjust
          self.clickOption(option, 0, adjust, 0)
        }
        */
        // is_mandatory default active
        this.adjusts.forEach(function (adjust, aIndex) {
          adjust[aSchema.option_list].forEach(function (option, oIndex) {
            if (option[oSchema.is_mandatory]) {
              self.clickOption(option, oIndex, adjust, aIndex)
            }
          })
        })
      })
    },
    initUpOptions () {
      // console.log(this.currentProduct)
      var pSchema = this.schema.product
      var cSchema = this.schema.combine
      var self = this
      // this.setBtnDis(false)
      this.clearOption()
      // this.itemSetNo = this.curOrderInfo.item_set_uid
      if (this.prodType === 'package') {
        var passCombinations = this.ruleValidation()
        this.price = this.calculatePriceBySelectedOptions(passCombinations)
      } else if (this.combineProductPrice) this.price = this.combineProductPrice
      else this.price = this.currentProduct[pSchema.price]
      this.combineId = this.currentProduct[pSchema.combine_list][cSchema.combine_id]
      this.productCombineIds = this.currentProduct[this.schema.product.combine_list]
      this.adjusts = this.showAll(this.currentProduct, this.productCombineIds)
      this.adjustsIndexMapping = this.createMapping(this.adjusts, this.schema.adjust.product_id)
      this.optionsIndexMapping = this.createOptionMapping(this.adjusts)
      this.$nextTick(function () {
        this.filterCombine(this.productCombineIds)
        // 若有停賣項目，清空，顯示wording
        if (this.checkDisOption) {
          this.show.reChoose = true
        } else if (this.curOrderInfo) {
          this.show.reChoose = false
          // 無停賣項目，選取已編輯產品
          if (this.curOrderInfo.adjusts) {
            // console.log(this.curOrderInfo)
            for (var i = 0; i < this.curOrderInfo.adjusts.length; i++) {
              for (var j = 0; j < this.curOrderInfo.adjusts[i].options.length; j++) {
                var option = self.getOption(this.curOrderInfo.adjusts[i].options[j].option_id)
                var adjust = self.getAdjust(this.curOrderInfo.adjusts[i].adjust_id)
                const oAmount = this.curOrderInfo.adjusts[i].options[j].amount
                for (var a = 0; a < oAmount; a++) {
                  self.clickOption(option, j, adjust, i)
                }
              }
            }
          }
        }
      })
    },
    checkAdjustDis (aId) {
      // console.log(this.disAdjust)
      // console.log(aId)
      var dis = this.disAdjust.find(function (o) { return o === aId })
      if (dis) {
        return false
      } else return true
    },
    checkOptionDis (oId, aId) {
      // console.log(this.disOption)
      // console.log(oId, aId)
      if (this.disOption[aId]) {
        var dis = this.disOption[aId].find(function (o) { return o.product_id === oId })
        if (dis) {
          return false
        } else return true
      } else {
        return true
      }
    }
  },
  ready () {
  },
  computed: {
    checkDisOption () {
      const list = this.curOrderInfo
      var disOption = 0
      if (list) {
        for (var i = 0; i < list.length; i++) {
          // 商品沒有停賣
          if (list.type === 1) {
            const aList = list[i].adjusts
            for (let i = 0; i < aList.length; i++) {
              // 調整項目停賣
              if (aList[i].is_disabled) {
                disOption = 1
                break
              }
              // 調整項目沒有停賣
              if (!disOption) {
                const oaList = aList[i].options
                for (let j = 0; j < oaList.length; j++) {
                  // 選項停賣
                  if (oaList[j].is_disabled) {
                    disOption = 1
                    break
                  }
                }
              }
            }
          }
        }
      }
      return disOption
    },
    minCombinePrice () {
      var oSchema = this.schema.option
      var price = 0
      // 如果combine沒有價格，此為最小的combine組合價格
      for (var i in this.isOption.length) {
        price = price + this.isOption[i].option[oSchema.price]
      }
      return price
    },
    combinePrice () {
      var minPrice
      var self = this
      var priceCombine = []
      var priceList = []
      if (this.productCombineIds.length) {
        for (var i = 0; i < this.productCombineIds.length; i++) {
          var item
          var price = this.getCombine(this.productCombineIds[i])[this.schema.combine.price]
          if (price === null) {
            var edgeList = this.getCombine(this.productCombineIds[i])[this.schema.combine.edge_list]
            for (var key in edgeList) {
              this.parsePrice(edgeList[key])
              if (this.parsePrice(edgeList[key]).type === 'p') price = this.parsePrice(edgeList[key]).price
            }
            // combine 無價格 (price 已經為最低的組合價格，非該combine的價格)
            item = {price: price + self.minCombinePrice, combine: this.getCombine(this.productCombineIds[i])}
            priceCombine.push(item)
          } else {
            // combine 有價格
            item = {price: price, combine: this.getCombine(this.productCombineIds[i])}
            priceCombine.push(item)
          }
        }
      }
      // 如果combine有的有價格，有的沒有在此比較
      for (var o in priceCombine) {
        priceList.push(priceCombine[o].price)
      }
      minPrice = Math.min.apply(Math, priceList)
      return minPrice
    },
    isBigMilk () {
      var pSchema = this.schema.product
      var product = this.currentProduct
      var productName = product[pSchema.name]
      if (productName) {
        if (productName.trim() === '綠光純鮮奶家庭號') return true
      }
      return false
    },
    isIce () {
      var pSchema = this.schema.product
      var product = this.currentProduct
      var productName = product[pSchema.name]
      if (productName) {
        if (productName.trim().indexOf('冰萃檸檬') > -1) return true
        if (productName.trim().indexOf('冰萃柳丁') > -1) return true
        if (productName.trim().indexOf('仙人掌冰茶') > -1) return true
        if (productName.trim().indexOf('綠豆鮮奶冰沙') > -1) return true
      }
      return false
    },
    combineProductPrice () {
      var minPrice
      var priceCombine = []
      var priceList = []
      var cSchema = this.schema.combine
      var eSchema = this.schema.edge
      if (this.productCombineIds.length) {
        for (var i = 0; i < this.productCombineIds.length; i++) {
          var item
          var price = null
          var edgeList = this.getCombine(this.productCombineIds[i])[cSchema.edge_list]
          for (var key in edgeList) {
            if (edgeList[key][eSchema.product_type] === 1) {
              price = edgeList[key][eSchema.price]
              item = {price: price, combine: this.getCombine(this.productCombineIds[i])}
              priceCombine.push(item)
            }
          }
        }
      }
      // 如果combine有的有價格，有的沒有在此比較
      for (var o in priceCombine) {
        priceList.push(priceCombine[o].price)
      }
      minPrice = Math.min.apply(Math, priceList)
      return minPrice
    }
  },
  mounted () {
    $('.q-numeric input').attr('maxlength', '2')
    $('.q-numeric input').attr('type', 'tel')
    $('.q-numeric input').keyup(function () {
      var e = $('.q-numeric input')
      if (isNaN(e.val())) {
        e.val(e.val().match(/[0-9]*/))
      }
    })
    // $('.q-numeric input').attr('disabled', true).css('-webkit-text-fill-color', '#333')
  },
  created () {
    if (this.currentProduct.length) {
      this.clearOption()
      this.init()
      this.addProduct()
    }
  },
  watch: {
    currentProduct: {
      handler () {
        this.clearOption()
        this.init()
      },
      deep: true
    },
    number () {
      if (!this.number) this.number = 1
    },
    price () {
      if (this.pAIndex) this.checkPrice(this.price, this.currentProduct, this.pAIndex)
      else this.checkPrice(this.price, this.currentProduct)
    },
    /*
    'productShow' () {
      if (!this.productShow) {
        this.clearOption()
        var self = this
        var aSchema = this.schema.adjust
        var oSchema = this.schema.option
        this.$nextTick(function () {
          this.adjusts.forEach(function (adjust, aIndex) {
            adjust[aSchema.option_list].forEach(function (option, oIndex) {
              if (option[oSchema.is_mandatory]) {
                self.clickOption(option, oIndex, adjust, aIndex)
              }
            })
          })
        })
      }
    },
    */
    productAmount () {
      this.number = this.productAmount
      // this.clearOption()
      this.addProduct()
      /*
      if (this.pAIndex) this.checkPrice(this.price, this.currentProduct, this.pAIndex)
      else this.checkPrice(this.price, this.currentProduct)
      */
    },
    aSameCheck () {
      this.addProduct()
      this.checkPrice(this.price, this.currentProduct)
      /*
      if (this.pAIndex) this.checkPrice(this.price, this.currentProduct, this.pAIndex)
      else this.checkPrice(this.price, this.currentProduct)
      */
    },
    combineId () {
      this.addProduct()
    }
  }
}
</script>

<style lang="sass" scoped>
.btn-option--active
  background: #3c8dbc
  color: whitesmoke
</style>



// WEBPACK FOOTER //
// MenuOptions.vue?bace676e